import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SiteHeader from "../components/SiteHeader";

const featuredGames = [
  {
    day: "Viernes",
    title: "Rocket League",
    desc: "Viernes es para Rocket League. Si salen ambas modalidades, vamos a correr 1v1 y también 3v3 por equipos, así que vale la pena llegar ready.",
    image: "/ROCKET-LEAGUE-PROMO-POST-1.png",
  },
  {
    day: "Sábado",
    title: "Mortal Kombat X",
    desc: "Mortal Kombat X llega con ese vibe de bracket que siempre prende el piso. Si te gusta el clutch, aquí es donde se pone buena la cosa.",
    image: "/Mortal-Kombat-post.png",
  },
  {
    day: "Sábado",
    title: "FC 26",
    desc: "FC 26 cae el sábado para la gente que quiere competir, vacilar y meterle fútbol en medio del corre y corre de Comic Con.",
    image: "/FC26-PROMO-POST.png",
  },
  {
    day: "Sábado",
    title: "StarCraft",
    desc: "StarCraft trae otra energía, más táctica, más cerebral, pero igual de intensa. Es parte de lo que hace que esta experiencia no se sienta igual a las demás.",
    image: "/STARCRAFT-PROMO-POST.png",
  },
];

const experiencePillars = [
  "Gaming y competencia en vivo",
  "Presencia oficial de PREL en el booth",
  "Experiencia pensada para comunidad y audiencia general",
  "Contenido, energía y visibilidad de marca",
];

const ballroomHighlights = [
  {
    title: "PREL PRESENTS: PEC's Got Talent",
    image: "/comiccon/pec-got-talent-flyer.png",
  },
  {
    title: "Mario Kart",
    image: "/comiccon/ballroom-a-prel.png",
  },
  {
    title: "Just Dance",
    image: "/comiccon/ballroom-a-prel.png",
  },
];

export default function ComicConPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";

  useEffect(() => {
    document.title = "PRCC26 | PREL Esports Experience";

    const setMeta = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property='${name}']` : `meta[name='${name}']`;
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        if (isProperty) tag.setAttribute("property", name);
        else tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", "Archivo del evento PRCC26 de Puerto Rico Esports League durante Puerto Rico Comic Con 2026.");
    setMeta("og:title", "PRCC26 | PREL Esports Experience", true);
    setMeta("og:description", "Archivo del evento, comunidad, competencia y presencia oficial de PREL durante Puerto Rico Comic Con 2026.", true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://www.puertoricoesportleague.com/prcc-2026", true);
    setMeta("og:image", "https://www.puertoricoesportleague.com/prcc.png", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("robots", "noindex,follow");

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://www.puertoricoesportleague.com/prcc-2026");
  }, []);

  return (
    <div className="min-h-screen bg-[#06070A] text-white">
      <SiteHeader current="/eventos" />

      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_55%_at_80%_20%,rgba(0,138,255,0.20)_0%,transparent_60%),radial-gradient(ellipse_50%_60%_at_10%_90%,rgba(206,17,38,0.18)_0%,transparent_55%)]" />
        <div className="absolute inset-0 opacity-20 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:56px_56px]" />
        <div className="max-w-[1500px] mx-auto px-4 sm:px-6 xl:px-8 pt-10 sm:pt-14 pb-12 sm:pb-16 relative z-10">
          <div className="flex items-center gap-4 sm:gap-5 md:gap-6 overflow-x-auto pb-1">
            <img src="/logo.png" alt="PREL" className="h-10 sm:h-12 md:h-16 w-auto object-contain shrink-0" />
            <div className="text-slate-500 text-xl font-black hidden md:block shrink-0">×</div>
            <img src="/prcc.png" alt="Puerto Rico Comic Con" className="h-10 sm:h-12 md:h-16 w-auto object-contain shrink-0" />
          </div>
          <p className="mt-6 sm:mt-8 text-[10px] sm:text-xs tracking-[0.24em] sm:tracking-[0.3em] uppercase text-[#CE1126]">Puerto Rico Esports League x Puerto Rico Comic Con 2026</p>
          <h1 className="mt-4 text-[clamp(2.1rem,10vw,6.5rem)] font-black leading-[0.92] uppercase break-words">
            PREL <span className="text-[#CE1126]">Esports Experience</span>
          </h1>
          <p className="mt-5 sm:mt-6 max-w-4xl text-slate-300 text-base sm:text-lg leading-relaxed">
            Puerto Rico Esports League estuvo en Puerto Rico Comic Con 2026 con una Esports Experience pensada para comunidad, competencia, presencia de marca y energía real de evento. Esta página queda como archivo de esa activación.
          </p>
          <div className="mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
            <a href="/eventos" className="px-5 py-3 rounded-xl bg-[#CE1126] text-white font-semibold text-center hover:bg-[#a50e1e] transition">{lang === "en" ? "Events" : "Eventos"}</a>
            <a href="/contacto" className="px-5 py-3 rounded-xl border border-white/15 text-white text-center hover:bg-white/5 transition">{lang === "en" ? "Talk to PREL" : "Hablar con PREL"}</a>
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-4 sm:px-6 xl:px-8 py-10 sm:py-14 grid lg:grid-cols-[1.2fr_1fr] gap-4 sm:gap-6">
        <article className="border border-white/10 bg-[#111722] p-5 sm:p-7 md:p-8">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-cyan-300">Qué es</p>
          <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl font-black uppercase leading-tight">Una presencia PREL hecha para PRCC26</h2>
          <p className="mt-4 text-slate-300 leading-relaxed text-base sm:text-lg">
            La idea no es solamente estar presentes. La idea es llevar una experiencia que se sienta viva, competitiva, visual y accesible para la gente que llegue al booth. PREL entra a PRCC26 con una propuesta pensada para conectar gaming, comunidad, cultura y entretenimiento en un mismo espacio.
          </p>
        </article>

        <article className="border border-white/10 bg-[#111722] p-5 sm:p-7 md:p-8">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-[#CE1126]">Lo que puedes esperar</p>
          <ul className="mt-4 space-y-3 text-sm sm:text-base text-slate-300 leading-relaxed">
            {experiencePillars.map((item) => (
              <li key={item}>• {item}</li>
            ))}
          </ul>
        </article>
      </section>

      <section className="max-w-[1500px] mx-auto px-4 sm:px-6 xl:px-8 pb-12 sm:pb-16">
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-[#CE1126]">Featured titles</p>
        <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl font-black uppercase">Agenda de juegos</h2>
        <div className="mt-5 sm:mt-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {featuredGames.map((game) => (
            <article key={`${game.day}-${game.title}`} className="border border-white/10 bg-[#111722] overflow-hidden">
              <img src={game.image} alt={game.title} className="w-full h-[220px] sm:h-[260px] md:h-[280px] object-cover" />
              <div className="p-5 sm:p-6">
                <p className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-cyan-300">{game.day}</p>
                <h3 className="mt-3 text-xl sm:text-2xl font-black uppercase leading-tight">{game.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-slate-300 leading-relaxed">{game.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-4 sm:px-6 xl:px-8 pb-12 sm:pb-16">
        <div className="border border-white/10 bg-[#0F1220] p-5 sm:p-7 md:p-10">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-[#CE1126]">Espacio adicional</p>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-6xl font-black uppercase leading-[0.95]">Ballroom A</h2>
          <p className="mt-4 max-w-3xl text-slate-300 text-base sm:text-lg leading-relaxed">
            Además del booth, también vamos a tener presencia en Ballroom A con actividades pensadas para entretener, mover la comunidad y crear momentos que la gente recuerde.
          </p>
          <div className="mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {ballroomHighlights.map((item) => (
              <article key={item.title} className="border border-white/10 bg-[#111722] overflow-hidden">
                <div className="bg-[#0B0F18] p-3 sm:p-4">
                  <img src={item.image} alt={item.title} className="w-full h-[220px] sm:h-[240px] object-contain" />
                </div>
                <div className="p-5 sm:p-6">
                  <p className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-cyan-300">Ballroom A</p>
                  <h3 className="mt-3 text-xl sm:text-2xl font-black uppercase leading-tight break-words">{item.title}</h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-4 sm:px-6 xl:px-8 pb-16 sm:pb-20">
        <div className="border border-white/10 bg-[#0F1220] p-5 sm:p-7 md:p-10 grid lg:grid-cols-[1.3fr_1fr] gap-5 sm:gap-6 items-start">
          <div>
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-[#CE1126]">Sigue pendiente</p>
            <h3 className="mt-2 text-2xl sm:text-3xl md:text-5xl font-black uppercase leading-[0.98]">Prepárense, nos vemos allí.</h3>
            <p className="mt-4 max-w-2xl text-sm sm:text-base text-slate-300 leading-relaxed">
              Esta página queda como referencia de la presencia de PREL en Puerto Rico Comic Con 2026. Si quieres seguir lo que viene, pendiente a nuestras redes, a próximos eventos y a futuras actualizaciones.
            </p>
          </div>

          <div className="border border-white/10 bg-[#111722] p-5 sm:p-6 md:p-7">
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.24em] sm:tracking-[0.3em] text-cyan-300">Acciones rápidas</p>
            <div className="mt-4 grid gap-3">
              <a href="/eventos" className="px-5 py-3 bg-cyan-400 text-black font-semibold text-center hover:brightness-110 transition">Ir a eventos</a>
              <a href="/eventos" className="px-5 py-3 border border-white/15 text-white text-center hover:bg-white/5 transition">Ver otros eventos</a>
              <a href="/contacto" className="px-5 py-3 border border-white/15 text-white text-center hover:bg-white/5 transition">Contacto comercial</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
